export const NOT_EXCEEDED = 'notExceeded';
export const EXCEEDED = 'exceeded';
export const CHOICE_BEST_GROUP = 'choice_best_group';
export const DEFAULT_TEXTS = {
  [NOT_EXCEEDED]: {
    title: 'Платная доставка',
    text: 'Добавьте товаров к заказу на сумму <b>{{productPrice}}&nbsp;₽</b> для бесплатной доставки',
  },
  [EXCEEDED]: {
    title: 'Поздравляем',
    text: 'Можно доставить курьером все {{productCount}} товаров в корзине бесплатно',
  },
  [CHOICE_BEST_GROUP]: {
    title: 'Поздравляем',
    text: 'Вы выбрали наиболее удобный способ получения заказа',
  },
};
export const PLACEHOLDER_MAP = {
  [NOT_EXCEEDED]: '{{productPrice}}',
  [EXCEEDED]: '{{productCount}}',
};
